<script>
export default {
    name: 'Page',
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (!vm.$addresses.total && vm.$user.isLoggedIn) vm.$addresses.fetch()
        })
    },
}
</script>

<template lang="pug">
.canteen-page.container-fluid.container-lg.pt-page 
    transition(name="fade" mode="out-in")
        router-view
</template>
